export default {
  setChartDateRange(state, chartDateRange) {
    state.chartDateRange = chartDateRange;
  },
  setSelectedMaaleParameter(state, newSelectedMaaleParameter) {
    state.selectedMaaleParameter = newSelectedMaaleParameter
  },
  setFromYear(state, newFromYear) {
    state.fromYear = newFromYear;
  },
  setToYear(state, newToYear) {
    state.toYear = newToYear;
  },
  setQueryExpression(state, queryExpression) {
    state.queryExpression = queryExpression;
  },
  setFilterValue(state, filterValue) {
    state.filterValues[filterValue.filterFieldName] = filterValue.filterQueryString;
  },  
  setActiveGeographicFilterMode(state, activeGeographicFilterMode) {
    state.activeGeographicFilterMode = activeGeographicFilterMode;
  },
  setUseMapExtent(state, useMapExtent) {
    state.useMapExtent = useMapExtent;      
  },
  setCurrentMapExtent(state, currentMapExtent) {
    state.currentMapExtent = currentMapExtent;      
  },
  setSelectedBasemap(state, payload) {
    state.selectedBasemap = payload;    
  },
  setSelectedColumns(state, payload) {
    state.selectedColumns = payload;    
  },
  setMainLayerSymbolSettings(state, payload) {
    state.mainLayerSymbolSettings = payload;
  },
  setSelectedColumnsOtherActors(state, payload) {
    state.selectedColumnsOtherActors = payload;    
  },
  setSelectedTimeSeries(state, payload) {
    state.selectedTimeSeries = payload;
  },
  setHideWelcomeMessageInFilterDrawer(state, payload) {
    localStorage.setItem("hideWelcomeMessageInFilterDrawer", payload);
    state.hideWelcomeMessageInFilterDrawer = payload;
  },
  setFilters(state, payload) {    
    state.filters = payload;
  },
  setSelectedTimeSeriesOtherActors(state, payload) {
    state.selectedTimeSeriesOtherActors = payload;    
  },
  setClickedTimeSeries(state, payload) {
    state.clickedTimeSeries = payload;
  },
  setBufferSettings(state, payload) {
    state.bufferSettings = payload;
  },
  setShowInfoDrawer(state, payload) {
    state.showInfoDrawer = payload;
  },
  setSplitSize(state, payload) {
    state.splitSize = payload;
  },
  setTimeSeriesCount(state, payload) {
    state.timeSeriesCount = payload;
  },
  setShowStationsFromOtherActors(state, payload) {
    state.showStationsFromOtherActors = payload;
  },
  updateMaaleParameterOptions(state, payload) {
    state.filters[0].filters[0].values[1].options = payload;
  },
  updateMaaleParameterCurrentValue(state, payload) {
    state.filters[0].filters[0].currentValue = payload;
  },
  updateMaaleStedCurrentValue(state, payload) {
    state.filters[0].filters[1].currentValue = payload;
  },
  updateMaaleStedValues(state, payload) {
    state.filters[0].filters[1].values = payload;
  },
  setQueryExpressionStationsFromOtherActors(state, payload) {
    state.queryExpressionStationsFromOtherActors = payload;
  },
  setActiveInfoDrawerTab(state, payload) {
    state.activeInfoDrawerTab = payload;
  },
  setShowPopups(state, payload) {
    state.showPopups = payload;
  },
  setFiltersAreLoading(state, payload) {
    state.filtersAreLoading = payload;
  },
  setShowSelectFeatureDialog(state, payload) {
    state.showSelectFeatureDialog = payload;
  },
  setActiveTableTab(state, payload) {
    state.activeTableTab = payload;
  },
  setShowFilterPanel(state, payload) {
    state.showFilterPanel = payload;
  },
  setYearFilterMode(state, payload) {
    state.yearFilterMode = payload;
  },
  setMapHasLoaded(state, payload) {
    state.mapHasLoaded = payload;
  }
};
